import React from 'react';

import { ReactComponent as MinimizeIcon } from 'Icons/minimize.svg'
import { ReactComponent as CloseIcon } from 'Icons/close.svg';
const MinimizedTrip = ({hideAddTrip, maximizeTrip})=>(
        <div className="pf ht-50 bg-dark flex flex-between flex-middle b-60 r-0 wt-400 curP br-5 pl-20 pr-20 mr-30">
            <div className="fs-18 fSemibold white-color flex-1 row-100 flex flex-middle" onClick={maximizeTrip}>Adding new trip</div>
            <div className="flex flex-between flex-middle wt-50">
                <MinimizeIcon className="stroke-white" onClick={maximizeTrip}/>
                <CloseIcon className="fill-white fill-op-1" onClick={hideAddTrip}/>
            </div>
        </div>
);

export default MinimizedTrip;